module.exports = __webpack_public_path__ + "static/media/arrowPrev.f9e46551.svg";